import { Component, EventEmitter, OnInit, Output, TemplateRef, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ChartService } from 'src/app/services/cl/chart/chart.service';
import { GlobalServiceService } from 'src/app/services/global/global-service.service';

export type TemplateReferenceObject = { ref: TemplateRef<any>, icon: string, mode: string, selected?: boolean , text: string };

@Component({
    selector: 'app-mode-provider',
    templateUrl: './mode-provider.component.html',
    styleUrls: ['./mode-provider.component.scss'],
    standalone: false
})
export class ModeProviderComponent implements OnInit, OnDestroy {
  currentTemplate: TemplateRef<any>;
  @Input()
  templateModes?: TemplateReferenceObject[] = [];
  @Output()
  modeSelected = new EventEmitter();
  showModes: boolean = false;
  urlAssets: string = localStorage.getItem('urlAssets');
  country = localStorage.getItem("userCountry");
  subscription: any;
  alertPY: boolean;
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private chartService: ChartService,
    public globalServiceService: GlobalServiceService
    ) {}
  ngOnInit() {
    this.templateModes
      .forEach(child => {
        if (child.mode && child.icon) {
          if (child.selected) {
            this.emitMode(child);
          }
        }
      })
    if (!this.currentTemplate && this.templateModes.length)
      this.emitMode(this.templateModes[0]);

    // CL mostrar Grafico de barras 0, Tabla de Rangos 1, Grafico de lineas 2, TABLAS 3
    this.subscription = this.chartService.bar$.subscribe((n) => {
      this.emitMode(this.templateModes[n]);
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  emitMode(mode: TemplateReferenceObject) {
    this.alertPY = this.globalServiceService.alertPY;
    switch (mode.text) {
      case $localize`Grafico de barras`:
        this.chartService.chart = 'bar';
        this.chartService.chart$.emit(true);
      break;
      case $localize`Grafico de lineas`:
        this.chartService.chart = 'line';
        this.chartService.chart$.emit(true);
      break;
      case $localize`tabla lista de personas`:
        this.chartService.chart = 'bar';
      break;
      default:
        this.chartService.chart = 'bar';
      break;
    }
    this.currentTemplate = null;
    this.changeDetectorRef.detectChanges();
    this.currentTemplate = mode.ref;
    this.changeDetectorRef.detectChanges();
    this.modeSelected.emit(mode.mode)
    this.showModes = false;
  }
}
